import React, { forwardRef } from 'react';
// import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Textarea = forwardRef((props, ref) => {
    return (
        <textarea
            className='w-full bg-surface-raised border-0 px-10 py-13 type-style-body rounded placeholder:text-grey-800/40'
            ref={ref}
            {...props} />
    );
});

Textarea.displayName = 'Textarea';

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

Textarea.propTypes = {};

export default Textarea;
